import React, { useEffect, useState } from "react";
import {StopData} from "../../../interfaces/routes/routeData";

interface IProps {
	alerts: any,
	direction: string,
	updateSelectedStop: (data: StopData) => void,
}

function ServiceAlert({alerts,direction,updateSelectedStop}: IProps) {
	const [showAlert, setShowAlert] = useState(false);
	const container = document.getElementById('schedule-map') as HTMLElement;
	const closedStopsUrl = container.dataset.closedstopPage;
	const activeAlerts = alerts.filter((serviceAlert: any) => serviceAlert.Direction === direction);
	const updateStopId = (e: React.SyntheticEvent) => {
		const target = e.target as HTMLElement;
		const id = target.dataset.stopId;
		const latitude = Number(target.dataset.lat);
		const longitude = Number(target.dataset.lng);
		if (id && latitude && longitude) {
			updateSelectedStop({
				id: id,
				lat: latitude,
				lng: longitude,
			});
		}
	}
	if (activeAlerts.length > 0) {
		return (
			<div className="service-alert">
				<button type="button" className="service-alert__header" onClick={() => setShowAlert(!showAlert)} aria-expanded={showAlert}>
					<svg className="service-alert__icon">
						<use href="#exclamation-triangle"></use>
					</svg>
					<p className="service-alert__label">
						Service alert(s) are in effect for this route
					</p>
				</button>
				{
					showAlert && activeAlerts.map((item: any) => {
						return (
							<div className="service-alert__content">
								<h3 className="service-alert__title">
									<a href={`${closedStopsUrl}?id=${item.ReferenceId}`} className="service-alert__link">{item.Title}</a>
								</h3>
								<span className="service-alert__value">{item.From} - {item.To}</span>
								<h4 className="service-alert__sub-heading">Stops closed:</h4>
								<ul className="service-alert__list">
									{
										item.AffectedStops.map((stop:any) => {
											return (
												<li className="stop-item" key={stop.Id}>
													<button type="button" className="stop-item__button" onClick={updateStopId} data-stop-id={stop.Id} data-lat={stop.Latitude} data-lng={stop.Longitude}>
														{stop.Name} {'('}Stop #{stop.Id}{')'}
													</button>
												</li>
											)
										})
									}
								</ul>
							</div>
						)
					})
				}
			</div>
		)
	} else {
		return null;
	}
}
export default ServiceAlert;